// extracted by mini-css-extract-plugin
module.exports = {"root":"selector_root__kG5ES","primary":"selector_primary__8MuMH","item":"selector_item__gC9gU","option":"selector_option__zlpPR"};